module.exports = __webpack_public_path__ + "static/show_packages-47ceb40243a8445d544927cf4076d90c.pdf";